import {createAction, createAsyncThunk} from '@reduxjs/toolkit'

import {getClient} from '@web/helpers/sbill'
import {isPC} from '@web/helpers/userAgent'
import {paymentAmountInfoSelectors} from '@web/selectors/paymentMethodInfo'
import {CardState} from '@web/slices/card/slice'
import {ChargePointState} from '@web/slices/chargePoint/slice'
import {mobileSelector, MobileState} from '@web/slices/mobile/slice'
import {orderAmountInfoSelector, OrderTotalState} from '@web/slices/orderTotal/slice'
import {PayLaterState} from '@web/slices/payLater/slice'
import {PaymentMethodState, paymentSelector} from '@web/slices/paymentMethod/slice'
import {PointPaymentState} from '@web/slices/pointPayment/slice'
import {RewardPointState} from '@web/slices/rewardPoint/slice'

type RootState = {
    orderTotal: OrderTotalState

    pointPayment: PointPaymentState
    rewardPoint: RewardPointState
    chargePoint: ChargePointState
    payLater: PayLaterState
    mobile: MobileState
    paymentMethod: PaymentMethodState
    card: CardState
}

type ThunkApi = {
    state: RootState
    rejectValue: string
}

/** 휴대폰 간편 비밀번호 분실 */
export const lostMobileEasyPin = createAsyncThunk<string, void, ThunkApi>('mobilePinLost', async (_, {getState}) => {
    const state = getState()
    const {orderAmount} = orderAmountInfoSelector(state)
    const {usingPayMethodAmount} = paymentAmountInfoSelectors(state)

    const {
        mobileEasyPay: {billing, phoneNumbers},
    } = mobileSelector(state)
    const {shopBill} = paymentSelector(state)

    const client = getClient({
        chnl: 'NV',
        authToken: shopBill.authToken,
        sid: billing.sid,
        svcType: shopBill.svcType,
        device: isPC ? 'PC' : 'MOBILE',
        amt: orderAmount,
        cpId: shopBill.cpId,
        itemId: shopBill.itemId,
        sellerId: shopBill.sellerId,
    })

    return new Promise<string>((resolve, reject) => {
        try {
            client.approve({
                payload: {
                    amount: usingPayMethodAmount.toString(),
                    title: shopBill.title,
                    domainUri: window.location.origin,
                    cellPhoneNo: phoneNumbers,
                    pgCp: billing.pgCp,
                    pgId: billing.pgId,
                    passwordLostYn: 'Y',
                },
                callback: {
                    onApproved: (approveArgs) => {
                        if (!approveArgs.success) {
                            return reject(approveArgs.message)
                        }
                        resolve(approveArgs.message)
                    },
                },
            })
        } catch (e) {
            client.clear()
            reject(e)
        }
    })
})

export const cancelEasyMobileRegistration = createAction('cancelEasyMobileRegistration')
